const bylawCourses = [
    { code: "CSE101", name: "Intro to Programming", credits: 3, mandatory: true, level: "Freshman" },
    { code: "CSE102", name: "Computer Basics", credits: 2, mandatory: true, level: "Freshman" },
    { code: "CSE201", name: "Data Structures", credits: 3, mandatory: true, level: "Sophomore" },
    { code: "CSE202", name: "Algorithms", credits: 3, mandatory: true, level: "Sophomore" },
    { code: "CSE301", name: "Operating Systems", credits: 3, mandatory: true, level: "Junior" },
    { code: "CSE302", name: "Database Systems", credits: 3, mandatory: true, level: "Junior" },
    { code: "CSE401", name: "Software Engineering", credits: 3, mandatory: true, level: "Senior" },
    { code: "CSE402", name: "Artificial Intelligence", credits: 3, mandatory: false, level: "Senior" },
    { code: "CSE451", name: "Cloud Computing", credits: 3, mandatory: false, level: "Senior" },
];

export default bylawCourses;
